import { SunnyRequestBuilder } from '@/models/Common/SunnyRequestBuilder';
import { ISearchAutoCompleteSuggestionRequestParams } from '@/models/SearchAutoComplete/interfaces/ISearchAutoCompleteSuggestionRequestParams';
import SearchAutoCompleteSuggestionJSC from '@/schema/SearchAutoCompleteSuggestionJSC';
import { IRequestWrap } from '@/server/IServer';
import { TReqConfigValidated } from '@/services/JSCService';
import { joinURL } from '@/utils';

export default class SearchAutoCompleteRequestBuilder extends SunnyRequestBuilder {
  static getBaseURIFromReq(req: IRequestWrap): URI {
    return req.config.SearchAutoComplete;
  }

  createGetSuggestionList(reqParams: ISearchAutoCompleteSuggestionRequestParams): TReqConfigValidated {
    return this.validate(SearchAutoCompleteSuggestionJSC, reqParams).map((params) =>
      this.makeConfig('GET', '/service/domestic/korail/v1_1/suggestions', params),
    );
  }

  protected getAPIEndpoint(path: string): string {
    const baseURI = this.baseURI.href();
    return baseURI ? joinURL(baseURI, path) : joinURL(baseURI, '/api/v1', path);
  }
}
